// src/index.js

import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import MarketingApp    from './apps/marketing/App';
import ConstructionApp from './apps/construction/App';

// Our Auth Provider
import { AuthProvider } from './apps/construction/features/Auth/context/AuthContext';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import Modal from 'react-modal';

Modal.setAppElement('#root');

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/myteconstruction/*" element={<ConstructionApp />} />
          <Route path="/*"                    element={<MarketingApp />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);

serviceWorkerRegistration.register();
reportWebVitals();
